import styled, { css } from "styled-components";

export const OptionWrapper = styled.div<{ checked: boolean }>`
  padding: ${({ theme }) => theme.spacings.xs2};
  border-radius: ${({ theme }) => theme.borders.radius.s};
  cursor: pointer;

  ${({ checked }) =>
    checked
      ? css`
          background-color: ${({ theme }) => theme.colors.secondary[95]};
        `
      : ""}

  &:hover {
    background-color: ${({ theme }) => theme.colors.neutral[95]};
  }
`;
